<template>
  <div
    v-click-outside="hide"
    class="button-switch-component d-flex align-items-center"
    :class="{ 'normal-style': !radius, 'radius-style': radius }"
  >
    <button
      type="button"
      v-for="(item, index) in options"
      :name="`button-switch-${item}`"
      :key="index"
      class="btn btn-block m-0"
      :class="{
        'btn-outline-secondary': current !== index,
        'btn-primary': current === index,
        'slim-size': slim,
        'radius-style': radius
      }"
      @click="changeDateType(index)"
    >
      {{ item.title }}
    </button>
    <div class="d-none d-lg-block">
      <date-picker
        v-model="dates"
        :visible="pickerVisible"
        @hide="hide"
        @submit="submit"
      />
    </div>
    <responsive-modal v-if="isMobile" v-model="pickerVisible">
      <date-picker
        v-model="dates"
        :visible="true"
        @hide="hide"
        @submit="submit"
        positionRelative
      />
    </responsive-modal>
  </div>
</template>
<script>
import vClickOutside from "v-click-outside";
import moment from "moment";

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    options: {
      type: Array,
      default: () => [
        { title: "Semana", rangeLength: 7 },
        { title: "Mês", rangeLength: 7 }
      ]
    },
    slim: {
      type: Boolean,
      default: false
    },
    radius: {
      type: Boolean,
      default: false
    },
    value: {
      //Value expect this: ['2021-05-10', '2021-05-17] [0] -> start_day -- [1] -> end_day
      type: Array,
      default: () => []
    }
  },
  watch: {
    current(val) {
      this.pickerVisible = true;
    }
  },
  computed: {
    isMobile() {
      return window.innerWidth < 991;
    }
  },
  data() {
    return {
      current: 0,
      pickerVisible: false,
      dates: undefined
    };
  },
  methods: {
    hide() {
      this.pickerVisible = false;
    },
    changeDateType(index) {
      if (this.options[index].rangeLength) {
        this.dates = [
          moment()
            .subtract(this.options[index].rangeLength, "days")
            .format("YYYY-MM-DD"),
          moment().format("YYYY-MM-DD")
        ];
      } else {
        this.dates = undefined;
      }
      this.current = index;
    },
    submit() {
      this.$emit("input", this.dates);
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

.button-switch-component {
  border: 1px solid #d2d0d8;
  border-radius: 20px;
  position: relative;

  .btn-outline-secondary:hover {
    background: transparent;
    color: $secondary;
    text-decoration: none;
    outline: none;
    border: 0;
  }

  button {
    border-width: 0;
  }

  .normal-style {
    &.btn-outline-secondary:not(:last-child):not(:first-child) {
      border-radius: 0px !important;
    }

    &.btn-outline-secondary:first-child {
      border-radius: 4px 0px 0px 4px !important;
      border-right-color: transparent;
    }

    &.btn-outline-secondary:last-child {
      border-radius: 0px 4px 4px 0px !important;
      border-left-color: transparent;
    }
  }

  .slim-size {
    min-height: 32px !important;
  }

  .btn-outline-primary,
  .btn-outline-secondary,
  .btn-primary,
  .btn-secondary {
    overflow: hidden;
    padding-left: 15px !important;
    padding-right: 15px !important;
    @media screen and (max-width: 1199px) {
      padding-left: 5px !important;
      padding-right: 5px !important;
      font-size: 12px;
    }
  }

  .radius-style {
    &.btn-outline-secondary:not(:last-child):not(:first-child) {
      border-radius: 0px !important;
    }

    &.btn-outline-secondary:first-child {
      border-radius: 20px 0px 0px 20px !important;
      border-right-color: transparent;
    }

    &.btn-outline-secondary:last-child {
      border-radius: 0px 20px 20px 0px !important;
      border-left-color: transparent;
    }

    &.btn-primary {
      border-radius: 20px;
    }

    &.btn-outline-secondary:not(:disabled):not(.disabled):active,
    &.btn-outline-secondary:not(:disabled):not(.disabled):active:focus,
    &:focus-visible {
      color: $secondary;
      background-color: transparent;
      border-color: transparent;
      outline: none;
      box-shadow: none;
      border: 0;
    }
  }
}
</style>
